import React, { useMemo } from 'react';
import { FlexSectionContainer } from "components/layout"
import { WithLoadingComponent, SVGLoader, ClockTemplate } from "components/shared";
import { KpiChart } from 'components/pages';

export const CustomAVGKpiHoc = (props) => {
    const CustomKPIHoc = useMemo(() => WithLoadingComponent(AvgProcessingTemplate, props.httpService, <SVGLoader label="Loading..." />)(props), []);
    return <CustomKPIHoc />
}

const AvgProcessingTemplate = (props) => {
    const { data } = props;
    return <FlexSectionContainer  title="Intervention AVG Processing">
        <KpiChart
            data={data}
            chart="column"
            title="Average KPI (by min)"
            size={{ height: 300, width: "33%" }} />
        {data.map(item => <div className="w-33 mt-4"><ClockTemplate title={item.dataName} content={`${item.dataValue} min`} /></div>)}
    </FlexSectionContainer>
}
